import React, { FC } from "react";
import { CircularProgress, Dialog, DialogContent, DialogTitle } from "@material-ui/core";

interface PendingDialogProps {
  open: boolean;
  title: string;
}

const PendingDialog: FC<PendingDialogProps> = ({ open, title }) => {

  return (
    <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
            <CircularProgress />
        </DialogContent>
      </Dialog>
  );
}

export default PendingDialog;